// extracted by mini-css-extract-plugin
export default {"image":"WVFBiCwjDQuMRKbrNJFz","title":"JwWbFlf7B1DTAbzJJQ2w","text":"_3lhoJAqgUUoRFvSi_f0","footer":"U2iqETLdLNfybb9sVVbT"};